import React, { useState } from 'react'
import { withTranslation } from 'react-i18next'
import CurrencyFormat from 'react-currency-format'
import FilterDropdown from './FilterDropdown'

const MAX_BUDGET = 1000000
const STEP = 5000

export default withTranslation()(function BudgetRangeFilter({ t, min, max, onApply, onClear }) {
  const [draftMin, setDraftMin] = useState(min ?? 0)
  const [draftMax, setDraftMax] = useState(max ?? MAX_BUDGET)

  const activeLabel = (min || max) && (min > 0 || max < MAX_BUDGET)
    ? `NGN ${(min ?? 0).toLocaleString()} - ${(max ?? MAX_BUDGET).toLocaleString()}`
    : null

  return (
    <FilterDropdown
      label={t('promo.listing.filters.budget_range')}
      active={activeLabel}
      panel={({ close }) => (
        <div className="flex flex-col gap-4">
          <div className="relative h-4">
            <div className="absolute top-1/2 -translate-y-1/2 w-full h-1 bg-background rounded-full" />
            <div
              className="absolute top-1/2 -translate-y-1/2 h-1 bg-primary rounded-full"
              style={{
                left: `${(draftMin / MAX_BUDGET) * 100}%`,
                right: `${100 - (draftMax / MAX_BUDGET) * 100}%`
              }}
            />
            <input
              type="range"
              min={0}
              max={MAX_BUDGET}
              step={STEP}
              value={draftMin}
              onChange={(event) => setDraftMin(Math.min(Number(event.target.value), draftMax - STEP))}
              className="absolute w-full appearance-none bg-transparent pointer-events-none accent-primary [&::-webkit-slider-thumb]:pointer-events-auto [&::-moz-range-thumb]:pointer-events-auto"
            />
            <input
              type="range"
              min={0}
              max={MAX_BUDGET}
              step={STEP}
              value={draftMax}
              onChange={(event) => setDraftMax(Math.max(Number(event.target.value), draftMin + STEP))}
              className="absolute w-full appearance-none bg-transparent pointer-events-none accent-primary [&::-webkit-slider-thumb]:pointer-events-auto [&::-moz-range-thumb]:pointer-events-auto"
            />
          </div>

          <div className="flex items-center gap-3">
            <label className="flex flex-col gap-1 text-xs text-secondary flex-1">
              {t('promo.listing.filters.min_budget')}
              <CurrencyFormat
                value={draftMin}
                thousandSeparator
                prefix="NGN "
                onValueChange={({ floatValue }) => setDraftMin(Math.min(floatValue ?? 0, draftMax - STEP))}
                className="border border-border-lines rounded-lg px-2 py-1.5 text-sm text-dark-blue w-full"
              />
            </label>

            <label className="flex flex-col gap-1 text-xs text-secondary flex-1">
              {t('promo.listing.filters.max_budget')}
              <CurrencyFormat
                value={draftMax}
                thousandSeparator
                prefix="NGN "
                onValueChange={({ floatValue }) => setDraftMax(Math.max(floatValue ?? MAX_BUDGET, draftMin + STEP))}
                className="border border-border-lines rounded-lg px-2 py-1.5 text-sm text-dark-blue w-full"
              />
            </label>
          </div>

          <div className="flex items-center justify-between gap-2">
            <button
              type="button"
              onClick={() => { setDraftMin(0); setDraftMax(MAX_BUDGET); onClear(); close() }}
              className="text-sm font-medium text-secondary"
            >
              {t('promo.listing.filters.clear')}
            </button>

            <button
              type="button"
              onClick={() => { onApply(draftMin, draftMax); close() }}
              className="bg-primary text-white text-sm font-medium rounded-full px-4 py-1.5"
            >
              {t('promo.listing.filters.apply')}
            </button>
          </div>
        </div>
      )}
    />
  )
})
